var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoPurcahseReplenishmentIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5234,
    cy: 29.5,
    r: 28.5,
    fill: "white",
    fillOpacity: 0.25,
    stroke: "#67768E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50221_26332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4227 14.2656H24.5827C23.769 14.2656 23.1094 14.9253 23.1094 15.739V18.6856C23.1094 19.4993 23.769 20.159 24.5827 20.159H33.4227C34.2364 20.159 34.8961 19.4993 34.8961 18.6856V15.739C34.8961 14.9253 34.2364 14.2656 33.4227 14.2656Z",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.891 17.2109H37.8376C38.6192 17.2109 39.3687 17.5214 39.9213 18.074C40.4739 18.6266 40.7843 19.3761 40.7843 20.1576V27.2958M23.1043 17.2109H20.1576C19.3761 17.2109 18.6266 17.5214 18.074 18.074C17.5214 18.6266 17.2109 19.3761 17.2109 20.1576V40.7843C17.2109 41.5658 17.5214 42.3153 18.074 42.8679C18.6266 43.4205 19.3761 43.731 20.1576 43.731H27.3047",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 24.2812H28.1167",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 26.6406H23.9913",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6797 37.6592V36.7699C30.6797 36.2444 31.1092 35.8099 31.6397 35.8099C32.5543 35.8099 32.9282 35.1632 32.4684 34.3699C32.2056 33.9151 32.3623 33.3239 32.8221 33.0612L33.6962 32.561C34.0954 32.3235 34.6108 32.465 34.8482 32.8641L34.9038 32.9601C35.3586 33.7534 36.1064 33.7534 36.5662 32.9601L36.6218 32.8641C36.8593 32.465 37.3746 32.3235 37.7738 32.561L38.648 33.0612C39.1078 33.3239 39.2644 33.9151 39.0016 34.3699C38.5418 35.1632 38.9158 35.8099 39.8303 35.8099C40.3558 35.8099 40.7903 36.2394 40.7903 36.7699V37.6592C40.7903 38.1847 40.3609 38.6193 39.8303 38.6193C38.9158 38.6193 38.5418 39.266 39.0016 40.0593C39.2644 40.5191 39.1078 41.1052 38.648 41.368L37.7738 41.8682C37.3746 42.1057 36.8593 41.9642 36.6218 41.565L36.5662 41.469C36.1114 40.6757 35.3636 40.6757 34.9038 41.469L34.8482 41.565C34.6108 41.9642 34.0954 42.1057 33.6962 41.8682L32.8221 41.368C32.3623 41.1052 32.2056 40.5141 32.4684 40.0593C32.9282 39.266 32.5543 38.6193 31.6397 38.6193C31.1092 38.6193 30.6797 38.1847 30.6797 37.6592Z",
    stroke: "#67768E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7332 38.3883C36.3798 38.3883 36.9039 37.8641 36.9039 37.2176C36.9039 36.571 36.3798 36.0469 35.7332 36.0469C35.0866 36.0469 34.5625 36.571 34.5625 37.2176C34.5625 37.8641 35.0866 38.3883 35.7332 38.3883Z",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7969 37C27.7969 38.5822 28.2661 40.129 29.1451 41.4446C30.0242 42.7602 31.2736 43.7855 32.7354 44.391C34.1972 44.9965 35.8057 45.155 37.3576 44.8463C38.9094 44.5376 40.3349 43.7757 41.4537 42.6568C42.5725 41.538 43.3345 40.1126 43.6432 38.5607C43.9518 37.0089 43.7934 35.4003 43.1879 33.9385C42.5824 32.4767 41.557 31.2273 40.2414 30.3482C38.9258 29.4692 37.3791 29 35.7969 29C33.5604 29.0084 31.4137 29.8811 29.8058 31.4356L27.7969 33.4444",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0191 33.441H27.7969V31.2188",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50221_26332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPurcahseReplenishmentIcon2);
export default __webpack_public_path__ + "static/media/AutoPurcahseReplenishmentIcon2.0a8b9163926c772c46c3ea429bffee18.svg";
export { ForwardRef as ReactComponent };